module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_date_range":"Select date range"},"cs":{"select_date_range":"Vyberte rozmezí dat"}}')
  delete Component.options._Ctor
}
